








import Vue from 'vue';

export default Vue.extend({
  name: 'instagram-icon',
  props: {
    color: {
      type: String,
      required: false,
      default: '#FFFFFF',
    },
  },
});
